import React from "react";
import compose from "recompose/compose";
import Button from "theme/components/atoms/Button";
import { H3 } from "theme/components/atoms/Typography/Heading";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import ExplainedCallToAction from "theme/components/organisms/ExplainedCallToAction/ExplainedCallToAction";
import Link from "theme/components/atoms/Typography/Link";
import withLogoutMutation from "theme/modules/User/Logout/withLogoutMutation";
import withIsWishlistEnabled from "theme/modules/Wishlist/withIsWishlistEnabled";
import { FormattedMessage } from "react-intl";
import withIsRequisitionListEnabled from "theme/modules/RequisitionList/withIsRequisitionListEnabled";
import { Restricted } from "web/core/permissions/CompanyPermissionsContext";
import { CompanyPermissionsProvider } from "web/core/permissions/CompanyPermissionsContext";

const AccountSubNavigation = ({
  user,
  logout,
  commandPending,
  wishlist,
  requisitionList,
}) => {
  return (
    <div className="account-sub-navigation">
      <div className="container">
        <ExplainedCallToAction
          title={
            <H3>
              <FormattedMessage
                id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.welcome"
                defaultMessage="Welcome {name}!"
                values={{ name: user.firstname }}
              />
            </H3>
          }
        >
          <ul className="account-sub-navigation__list">
            <li className="account-sub-navigation__item">
              <Link to="/user">
                <LabelledIcon icon="cog">
                  <FormattedMessage
                    id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.dashboard"
                    defaultMessage="My dashboard"
                  />
                </LabelledIcon>
              </Link>
            </li>
            <li className="account-sub-navigation__item">
              <Link to="/user/orders">
                <LabelledIcon icon="shirt">
                  <FormattedMessage
                    id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.orders"
                    defaultMessage="My orders"
                  />
                </LabelledIcon>
              </Link>
            </li>
            <CompanyPermissionsProvider>
              <Restricted to="negotiableQuote.view">
                <li className="account-sub-navigation__item">
                  <Link to="/user/negotiable-quotes">
                    <LabelledIcon icon="paper">
                      <FormattedMessage
                        id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.negotiableQuotes"
                        defaultMessage="My quotes"
                      />
                    </LabelledIcon>
                  </Link>
                </li>
              </Restricted>
            </CompanyPermissionsProvider>
            {requisitionList?.isFeatureActive && (
              <li className="account-sub-navigation__item">
                <Link to="/user/requisition-lists">
                  <LabelledIcon icon="list">
                    <FormattedMessage
                      id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.requisitionLists"
                      defaultMessage="My requisition lists"
                    />
                  </LabelledIcon>
                </Link>
              </li>
            )}
            {wishlist?.isFeatureActive ? (
              <li className="account-sub-navigation__item">
                <Link to="/user/wishlist">
                  <LabelledIcon icon="heart">
                    <FormattedMessage
                      id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.wishlist"
                      defaultMessage="My wishlist"
                    />
                  </LabelledIcon>
                </Link>
              </li>
            ) : null}
            <li className="account-sub-navigation__item">
              <Button
                appearance="link"
                state={commandPending ? "pending" : undefined}
                onClick={() => logout("/")}
              >
                <LabelledIcon icon="exit">
                  <FormattedMessage
                    id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.logout"
                    defaultMessage="Log out"
                  />
                </LabelledIcon>
              </Button>
            </li>
            <li className="account-sub-navigation__item">
              <Link to="/contact">
                <LabelledIcon icon="envelope">
                  <FormattedMessage
                    id="layouts.Header.Navigation.AccountNavigation.AccountSubNavigation.contact"
                    defaultMessage="Contact"
                  />
                </LabelledIcon>
              </Link>
            </li>
          </ul>
        </ExplainedCallToAction>
      </div>
    </div>
  );
};

export default compose(
  withIsRequisitionListEnabled(),
  withIsWishlistEnabled(),
  withLogoutMutation()
)(AccountSubNavigation);
